import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { MessageCreateTemplate } from 'components/Templates'

const MessageEdit: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const id = /^\/customer\/message\/[a-zA-Z0-9]+$/.test(pathname) ? pathname.split('/customer/message/')[1] : undefined

  return (
    <Layout headline={'メッセージ配信'} iconPath={'/icon/white/message.svg'} title={'メッセージ配信'}>
      <MessageCreateTemplate id={id} />
    </Layout>
  )
}

export default MessageEdit
